import { render, staticRenderFns } from "./DeficientesCard.vue?vue&type=template&id=b786e9dc"
import script from "./DeficientesCard.vue?vue&type=script&lang=js"
export * from "./DeficientesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports